/* Northline product page: swipe gallery progress bar (mobile). */
if (!customElements.get('nl-gallery-progress')) {
  class NlGalleryProgress extends HTMLElement {
    connectedCallback() {
      this.list = this.closest('slider-component')?.querySelector('.product__media-list');
      this.bar = this.querySelector('.nl-gallery-progress__bar');
      if (!this.list || !this.bar) return;
      this.update = this.update.bind(this);
      this.list.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
      setTimeout(this.update, 300);
    }

    disconnectedCallback() {
      if (!this.list) return;
      this.list.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }

    update() {
      const slides = Array.from(this.list.querySelectorAll('.slider__slide')).filter(
        (slide) => slide.offsetParent !== null
      );
      const count = Math.max(slides.length, 1);
      this.classList.toggle('nl-gallery-progress--single', count < 2);
      const max = Math.max(this.list.scrollWidth - this.list.clientWidth, 1);
      const progress = Math.min(Math.max(this.list.scrollLeft / max, 0), 1);
      this.bar.style.width = 100 / count + '%';
      this.bar.style.transform = 'translateX(' + progress * (count - 1) * 100 + '%)';
    }
  }
  customElements.define('nl-gallery-progress', NlGalleryProgress);
}

/* Delivery strip: live countdown to the same-day dispatch cut-off (UK time, Mon to Fri). */
if (!customElements.get('nl-delivery-strip')) {
  class NlDeliveryStrip extends HTMLElement {
    connectedCallback() {
      this.line = this.querySelector('[data-delivery-line]');
      this.cutoff = parseInt(this.dataset.cutoff || '15', 10);
      if (!this.line) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        }).formatToParts(new Date());
      } catch (e) {
        return;
      }
      const get = (type) => (parts.find((p) => p.type === type) || {}).value;
      const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday'));
      const now = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
      const cut = this.cutoff * 60;
      if (day >= 0 && day <= 4 && now < cut) {
        const left = cut - now;
        const h = Math.floor(left / 60);
        const m = left % 60;
        this.line.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for same-day dispatch';
      } else {
        const next = day >= 4 || day < 0 ? 'Monday' : 'tomorrow';
        this.line.innerHTML = 'Order now for dispatch <strong>' + next + '</strong>';
      }
    }
  }
  customElements.define('nl-delivery-strip', NlDeliveryStrip);
}
